module.exports = __webpack_public_path__ + "static/media/OpenBrowser.d15b88b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/OpenBrowser.jpg
// module id = 2155
// module chunks = 0